// スタッフ訪問の希望日カレンダー（2026-09-11）。マンション版 VisitCalendar.tsx と同じ振る舞い。
// API が返す候補日（定休日・臨時休業・直近を除外済み）を月ごとの格子で出し、第1〜第3希望まで選ぶ。
// 選べない日は押せない（休みの日を選んで後から断る手戻りを無くす）。
const WD = ['日', '月', '火', '水', '木', '金', '土'];

export const VisitCalendar = ({ days, picks, onChange, max = 3 }) => {
  const months = new Map();
  for (const d of days) {
    const k = d.date.slice(0, 7);
    if (!months.has(k)) months.set(k, []);
    months.get(k).push(d);
  }
  const toggle = (d) => {
    if (!d.available) return;
    if (picks.includes(d.date)) { onChange(picks.filter((p) => p !== d.date)); return; }
    if (picks.length >= max) return;
    onChange([...picks, d.date]);
  };
  const fmt = (ymd) => {
    const [, m, dd] = ymd.split('-').map(Number);
    const dow = days.find((x) => x.date === ymd)?.dow_ja ?? '';
    return `${m}/${dd}（${dow}）`;
  };
  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10, minHeight: 28 }}>
        {picks.length === 0 && <span style={{ fontSize: 13, color: '#666' }}>ご希望日を{max}つまで選べます（タップで選択）</span>}
        {picks.map((p, i) => (
          <button key={p} type="button" onClick={() => onChange(picks.filter((x) => x !== p))}
            style={{ border: '1px solid #0e7490', color: '#0e7490', background: '#ecfeff', borderRadius: 999, padding: '4px 10px', fontSize: 13 }}>
            第{i + 1}希望 {fmt(p)} ✕
          </button>
        ))}
      </div>
      {[...months.entries()].map(([ym, list]) => {
        const [y, m] = ym.split('-').map(Number);
        const lead = list[0].dow;
        return (
          <div key={ym} style={{ marginBottom: 14 }}>
            <div style={{ fontWeight: 700, fontSize: 14, margin: '4px 0 6px' }}>{y}年{m}月</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
              {WD.map((w, i) => (
                <div key={w} style={{ textAlign: 'center', fontSize: 11, color: i === 0 ? '#c0392b' : i === 6 ? '#2563eb' : '#666' }}>{w}</div>
              ))}
              {Array.from({ length: lead }).map((_, i) => <div key={`pad${i}`} />)}
              {list.map((d) => {
                const idx = picks.indexOf(d.date);
                const day = Number(d.date.slice(8, 10));
                const base = { height: 40, borderRadius: 8, fontSize: 14, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd', background: '#fff' };
                const style = !d.available
                  ? { ...base, color: '#bbb', background: '#f3f4f6', textDecoration: 'line-through' }
                  : idx >= 0
                    ? { ...base, background: '#0e7490', color: '#fff', borderColor: '#0e7490', fontWeight: 700 }
                    : { ...base, color: d.dow === 0 ? '#c0392b' : d.dow === 6 ? '#2563eb' : '#111' };
                return (
                  <button key={d.date} type="button" disabled={!d.available} onClick={() => toggle(d)} style={style}>
                    <span>{day}</span>
                    {idx >= 0 && <span style={{ fontSize: 9, lineHeight: 1 }}>第{idx + 1}</span>}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
      <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>グレーの日はお休みのため選べません。日程は担当店で確認のうえ確定してご連絡いたします。</div>
    </div>
  );
};
